import { TabContext, TabList, TabPanel } from '@mui/lab';
// MUI から Stack、Tab コンポーネントをインポート
import { Stack, Tab } from '@mui/material';
// React とフックをインポート
import React, { SyntheticEvent } from 'react';
// react-hook-form から UseFormReturn フックをインポート
import { UseFormReturn } from 'react-hook-form';
// react-i18next から useTranslation フックをインポート
import { useTranslation } from 'react-i18next';
// react-redux から useDispatch フックをインポート
import { useDispatch } from 'react-redux';
// Redux ストアセレクターをインポート
import { RootState, useAppSelector } from 'src/redux/store';
import { CALENDAR_EDIT_TAB_VALUE, TabValue } from '../constants';
import { setTabValue } from '../store/enqueteCalendarSlice';
import { CalendarInput } from './CalendarInput';

// プロパティインターフェースを定義
export interface CalendarFormProps {
  // react-hook-form のメソッド
  methods: UseFormReturn;
}

// カレンダー詳細フォームをまとめるコンポーネント
export const CalendarForm: React.FC<CalendarFormProps> = (props) => {
  // パラメータ
  const { methods } = props;
  // タブ値
  const tabValue = useAppSelector((state: RootState) => state.enqueteCalendar.tabValue);
  // 翻訳関数を取得
  const { t } = useTranslation();
  // Redux dispatch 関数を取得
  const dispatch = useDispatch();
  //タブ切り替え関数
  const handleChangeTab = (_e: SyntheticEvent, newValue: TabValue) => {
    dispatch(setTabValue(newValue));
  };

  return (
    <TabContext value={tabValue}>
      <TabList onChange={handleChangeTab}>
        {/* 日本語 */}
        <Tab label={t('CalendarCreate.tab.japanese')} value={CALENDAR_EDIT_TAB_VALUE.JAPANESE} />
        {/* 英語 */}
        <Tab label={t('CalendarCreate.tab.english')} value={CALENDAR_EDIT_TAB_VALUE.ENGLISH} />
      </TabList>
      {/* 日本語タブ */}
      <TabPanel value={CALENDAR_EDIT_TAB_VALUE.JAPANESE}>
        <Stack spacing={2}>
          <CalendarInput methods={methods} formLabel="calendarJpn" />
        </Stack>
      </TabPanel>
      {/* 英語タブ */}
      <TabPanel value={CALENDAR_EDIT_TAB_VALUE.ENGLISH}>
        <Stack spacing={1}>
          <CalendarInput methods={methods} formLabel="calendarEng" />
        </Stack>
      </TabPanel>
    </TabContext>
  );
};
